import { useState, type FormEvent } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errorMessage } from "../api/client";
import type { Me } from "../api/types";
import { Logo } from "../components/ui";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const qc = useQueryClient();
  const nav = useNavigate();
  const from = (useLocation().state as { from?: string } | null)?.from;

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const me = await api<Me>("/auth/login", { json: { email, password } });
      qc.setQueryData(["me"], me);
      nav(from && from !== "/login" ? from : "/", { replace: true });
    } catch (err) {
      setError(errorMessage(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <main className="login">
      <form className="tile" onSubmit={submit} aria-labelledby="login-title">
        <div className="row"><Logo size={40} /><div><div className="lbl">Prospection CRM</div><h1 id="login-title" style={{ margin: 0, fontSize: 26 }}>Connexion</h1></div></div>
        <label className="field">Email
          <input className="input" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
        </label>
        <label className="field">Mot de passe
          <input className="input" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <div className="error" role="alert">{error}</div>}
        <button className="btn primary" type="submit" disabled={busy} style={{ height: 42 }}>{busy ? "Connexion…" : "Se connecter"}</button>
      </form>
    </main>
  );
}
